export enum BarrierPositioningCommand {
        Schrankenantrieb_abgestellt = 0,
        Nullstellung = 1,
        Sperrstellung = 2
}

export function getPositioningCmdString(positioningCmd: BarrierPositioningCommand): string {
    switch (positioningCmd) {
         case BarrierPositioningCommand.Schrankenantrieb_abgestellt:
            return 'Stop';
        case BarrierPositioningCommand.Nullstellung:
            return 'Auf'
        case BarrierPositioningCommand.Sperrstellung:
            return 'Zu'
}

/*export function getEscalationLevelSelect(): { name: string, id: number }[] {
    return [
        { name: getEscalationLevelString(EscalationLevel.S0), id: 0 },
        { name: getEscalationLevelString(EscalationLevel.S30), id: 30 },
        { name: getEscalationLevelString(EscalationLevel.S20), id: 20 },
        { name: getEscalationLevelString(EscalationLevel.S1), id: 1 },
        { name: getEscalationLevelString(EscalationLevel.S2), id: 2 },
        { name: getEscalationLevelString(EscalationLevel.S3), id: 3 },
        { name: getEscalationLevelString(EscalationLevel.S4), id: 4 },
        { name: getEscalationLevelString(EscalationLevel.S5), id: 5 },
        /*      { name: getEscalationLevelString(EscalationLevel.S6), id: 6 },
             { name: getEscalationLevelString(EscalationLevel.S7), id: 7 },
             { name: getEscalationLevelString(EscalationLevel.S8), id: 8 },
             { name: getEscalationLevelString(EscalationLevel.S9), id: 9 },
             { name: getEscalationLevelString(EscalationLevel.S10), id: 10 },
             { name: getEscalationLevelString(EscalationLevel.S15), id: 15 }, */


        /*       { name: getEscalationLevelString(EscalationLevel.S40), id: 40 },
              { name: getEscalationLevelString(EscalationLevel.S50), id: 50 },
              { name: getEscalationLevelString(EscalationLevel.S100), id: 100 } */
    /*];*/
}
